var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('ClientDrugSchedulePager',{attrs:{"date":_vm.date},on:{"change-date":_vm.changeDate}}),_c('ClientDrugScheduleList',{attrs:{"date":_vm.date,"prescriptions":_vm.data,"times":_vm.times}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }